import styled from "styled-components";
import SpinnerIcon from "assets/icons/spinner.svg";

const Spinner = styled.img`
  width: 25px;
  height: 25px;
`;

Spinner.defaultProps = {
  src: SpinnerIcon,
};

export { Spinner };
